import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Menu } from "../../../onboarding/components/create-user-admin/create-user-admin.component";

export interface SubMenu {
  id: string;
  label: string;
  url: string;
}

interface MenuWithSelection extends Menu {
  selected: boolean;
  subMenu: (SubMenu & { selected: boolean })[];
}

@Component({
  selector: 'app-dialog-moduls',
  templateUrl: './dialog-moduls.component.html',
  styleUrls: ['./dialog-moduls.component.scss']
})
export class DialogModulsComponent {

  dataMapped: MenuWithSelection[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { data: Menu[], fila: any },
    private dialogRef: MatDialogRef<DialogModulsComponent>
  ) {
    this.dataMapped = this.data.data.map(m => ({
      ...m,
      selected: false,
      showSubmenu: false,
      subMenu: (m.subMenu ?? []).map((sm: SubMenu) => ({
        ...sm,
        selected: false
      }))
    }))
      .filter(m => {
        const key = m.menuKey.split(",")[0]; // solo toma el nombre principal
        return !['ayuda', 'misDatos', 'MisProductos', 'preguntas'].includes(key);
      });

    this.applyUserSelection();
  }
  private applyUserSelection() {
    const fila = this.data.fila;
    if (!fila) return;

    this.dataMapped.forEach(module => {
      const [menuKey, subMenuKey] = module.menuKey.split(",");

      const moduleValue = fila[menuKey];
      if (moduleValue && moduleValue === module.id) {
        module.selected = true;
        module.showSubmenu = true;
      }

      // --- Seleccionar submenús ---
      const subMenuValue = fila[subMenuKey];
      if (subMenuValue && typeof subMenuValue === "string") {
        const ids = subMenuValue.split(",");

        module.subMenu.forEach(sm => {
          if (ids.includes(sm.id)) {
            sm.selected = true;
          }
        });

        if (module.subMenu.every(sm => sm.selected)) {
          module.selected = true;
        }
      }
    });
  }

  toggleModule(module: MenuWithSelection) {
    module.showSubmenu = !module.showSubmenu;
    module.subMenu.forEach(sm => sm.selected = module.selected);
  }

  toggleSubmodule(module: MenuWithSelection, sub: SubMenu & { selected: boolean }) {

    const allSelected = module.subMenu.every(sm => sm.selected);

    if (allSelected) {
      module.selected = true;
    }

    const noneSelected = module.subMenu.every(sm => !sm.selected);
    if (noneSelected) {
      module.selected = false;
      module.showSubmenu = false;
    }
  }


  /** Selección masiva */
  selectAll(value: boolean) {
    this.dataMapped.forEach(module => {
      module.selected = value;
      module.subMenu.forEach(sm => sm.selected = value);
    });
  }


  close() {
    const selectedModules = this.dataMapped
      .filter(m => m.selected || m.subMenu.some(sm => sm.selected));

    const payload = this.buildPayload(selectedModules);
    this.dialogRef.close(payload);
  }

  private normalizeLabel(label: string): string {
    if (!label) return "";

    let text = label.toLowerCase().trim();

    text = text.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

    if (text.endsWith("es")) text = text.slice(0, -2);
    else if (text.endsWith("s")) text = text.slice(0, -1);

    const mapping: Record<string, string> = {
      integracione: "integracion",
      integraciones: "integracion",
      autorizacione: "autorizacion",
      autorizaciones: "autorizacion",
      pqrs: "pqr",
      reporte: "reportes",
      reportes: "reportes",
      usuario: "usuarios",
      usuarios: "usuarios",
      vitale: "vitales",
      vitals: "vitales",
      ayudad: "ayuda",
    };

    return mapping[text] ?? text;
  }

  buildPayload(selectedModules: any[]): Record<string, string> {
    const payload: Record<string, string> = {};

    selectedModules.forEach(module => {

      const [menuKey, subMenuKey] = module.menuKey.split(",");

      payload[menuKey] = module.id;

      const subSelected = (module.subMenu ?? [])
        .filter((sm: any) => sm.selected)
        .map((sm: any) => sm.id);

      payload[subMenuKey] =
        subSelected.length > 0 ? subSelected.join(",") : "0";
    });

    return payload;
  }


  private capitalize(text: string): string {
    return text.charAt(0).toUpperCase() + text.slice(1);
  }

}
